export const AUDIT_LOG_LICENSE_TITLE = "Auditlog is disabled";
export const AUDIT_LOG_LICENSE_TEXT = "No new auditlog entries will be written because there is no valid license.";
